import { AxiosError } from 'axios';
import { IClientOverview } from '../../types/clients/IClientOverview';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';

export const getClientOverviewAsync = async (clientId: string): Promise<IClientOverview> =>
  APIFactory(baseUrlService.ApiLocation)
    .get(`/timber/api/internal/client_companies/${clientId}`)
    .then((response) => response.data)
    .catch((e: AxiosError) => {
      if (e.response && e.response.status === 404) {
        return Promise.resolve({ client: [] });
      } else {
        return axiosErrorHandler(e);
      }
    });
